// Bayesian average
//
// For 80% credibility with half-star resolution assuming consensus,
// we need aprox. 23 observations
// https://www.evanmiller.org/ranking-items-with-star-ratings.html

const rating = (ratings, { belief = 0.8, sampleSize = 23 } = {}) => {
  const n = ratings.length;
  const c = Math.max(sampleSize - n, 0);

  const p = ratings.reduce((a, b) => a + b, 0);

  return (c * belief + p) / (c + n);
};

// eslint-disable-next-line import/prefer-default-export
export { rating };
